import {createSlice} from '@reduxjs/toolkit';
import {
    deviceRegisterAPI,
    contactResearchAssistantAPI,
    contactMoreInformationAPI,
    recordActivityAPI
} from '../api/registerAPI';

const initialState = {
    createContactResearchAssistantError: null,
    createContactResearchAssistantSuccess: null,
    createRecordActivityError: null,
    createRecordActivitySuccess: null
};

export const registerSlice = createSlice({
    name: 'register',
    initialState,
    reducers: {
        createContactResearchAssistantError(state, action) {
            state.createContactResearchAssistantError = action.payload
        },
        createContactResearchAssistantSuccess(state, action) {
            state.createContactResearchAssistantSuccess = action.payload
        },
        createRecordActivityError(state, action) {
            state.createRecordActivityError = action.payload
        },
        createRecordActivitySuccess(state, action) {
            state.createRecordActivitySuccess = action.payload
        },
    },
    extraReducers: (builder) => {
        // builder
        //   .addCase(incrementAsync.pending, (state) => {
        //     state.status = 'loading';
        //   })
        //   .addCase(incrementAsync.fulfilled, (state, action) => {
        //     state.status = 'idle';
        //     state.value += action.payload;
        //   });
    },
});

export const {
    createContactResearchAssistantError,
    createContactResearchAssistantSuccess,
    createRecordActivityError,
    createRecordActivitySuccess
} = registerSlice.actions;

export const deviceRegister = (data, callback) => async (dispatch, getState) => {
    const response = await deviceRegisterAPI(data)
    if (callback) callback(response)
    return response;
};
export const contactResearchAssistant = (id, data, callback) => async (dispatch, getState) => {
    try {
        const response = await contactResearchAssistantAPI(id, data)
        if (response) {
            dispatch(createContactResearchAssistantSuccess(response.message))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(createContactResearchAssistantError(forgetError))
    }
};
export const recordActivity = (id, data, callback) => async (dispatch, getState) => {
    try {
        const response = await recordActivityAPI(id, data)
        if (response) {
            dispatch(createRecordActivitySuccess(response.message))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(createRecordActivityError(forgetError))
    }
};
export const contactMoreInformation = (id, data, callback) => async (dispatch, getState) => {
    try {
        const response = await contactMoreInformationAPI(id, data)
        if (response) {
            dispatch(createContactResearchAssistantSuccess(response.message))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(createContactResearchAssistantError(forgetError))
    }
};

export default registerSlice.reducer;
